import { ratingArray } from "constants/list"
import { t } from "i18next"
import { localisedValue, mapKeysToValues } from "utils"

const entitykeyMap = {
  lead: "inquiryId",
  meeting: "taskId",
  call: "phoneCallId",
}

const leadReviewTransformer = response => {
  const data = response?.data?.rows?.map((item, index) => {
    const reviewer = {
      id: item?.reviewer?.id,
      name: localisedValue({ object: item?.reviewer, key: "name" }),
      city: localisedValue({ object: item?.reviewer, key: "city" }),
      designation: localisedValue({ object: item?.reviewer, key: "designationShort" }),
    }
    const ratingObject = mapKeysToValues(ratingArray(), "id", "label")
    return {
      ...item,
      lead: {
        id: item?.inquiryId,
        flagIds: item?.categoryMappings?.map(category => category?.InternalInquiryCategory?.id),
      },
      reviewAgainstId: item?.[entitykeyMap[item?.entityType]],
      showAlertIcon: item?.type === "audit_review",
      // classificationKey: item?.InternalInquiry?.InternalInquiryClassification?.key,
      // isAddedToWatchList: item?.InternalInquiry?.InternalInquiryWatchlists?.length,
      isFlagged: item?.categoryMappings?.length > 0,
      // leadCreated: item?.InternalInquiry?.createdAt,
      // reviewCreated: item?.createdAt,
      reviewer,
      remarks: localisedValue({ object: item, key: "remarks" }),
    }
  })
  return {
    count: response?.data?.count,
    data,
  }
}

export default leadReviewTransformer
